import "./Loading.css";

export const Loading = () => (
  <div className="loading" role="status" aria-label="Loading">
    <span className="loading-spinner" />
  </div>
);

export default Loading;
